/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { AccessionPrefix } from './AccessionPrefix';
import type { LISCaseListBlock } from './LISCaseListBlock';
import type { LISCaseListPatient } from './LISCaseListPatient';
import type { LISCaseListSlide } from './LISCaseListSlide';
import type { LISCaseListSpecimen } from './LISCaseListSpecimen';
import type { LISWork } from './LISWork';

export type LISCaseList = {
    readonly id?: number;
    readonly ordering_doctor_id?: number;
    readonly supervising_physician_id?: number;
    readonly finalize_assignment_id?: number;
    readonly active_assignment_id?: number;
    work_processes: Array<LISWork>;
    specimens: Array<LISCaseListSpecimen>;
    blocks: Array<LISCaseListBlock>;
    slides: Array<LISCaseListSlide>;
    patient: LISCaseListPatient;
    /**
     * The Accession Number of the Case
     */
    accession: string | null;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    readonly updated_at?: string;
    /**
     * Changing this value will NOT modify the collected_date for each specimen.
     */
    collected_date?: string | null;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
    /**
     * Order id get from order message from third party, e.g. ModMed
     */
    external_order_id?: string | null;
    /**
     * current workflow status of the case
     */
    status?: LISCaseList.status;
    priority?: LISCaseList.priority;
    /**
     * case billing type: Third-Party Bill, Client Bill, Cash Pay, or No Bill
     */
    billing_type?: LISCaseList.billing_type | null;
    /**
     * True if the patient is paying cash; i.e. no insurance. Aka self-pay
     */
    self_pay?: boolean;
    /**
     * True if the patient is paying cash with an attestation; i.e. no insurance. Aka self-pay with attestation
     */
    self_pay_with_attestation?: boolean;
    /**
     * True if the patient has an indigent pay agreement.
     */
    indigent?: boolean;
    readonly grossed_by_cert_id?: number;
    readonly grossed_by_external_lab_id?: number;
    readonly billing_type_default?: LISCaseList.billing_type_default | null;
    readonly bill_tc_default?: boolean | null;
    readonly bill_pc_default?: boolean | null;
    readonly prefix_default?: Array<AccessionPrefix>;
    type?: LISCaseList.type;
    /**
     * This case is intended to be read on glass
     */
    glass_read?: boolean;
    _meta?: {
        created?: {
            documents?: Array<number>,
            specimens?: Array<number>,
            blocks?: Array<number>,
            slides?: Array<number>,
        },
        updated?: {
            documents?: Array<number>,
            specimens?: Array<number>,
            blocks?: Array<number>,
            slides?: Array<number>,
        },
        cassette_printing_task_id?: number,
    };
}

export namespace LISCaseList {

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }

    /**
     * case billing type: Third-Party Bill, Client Bill, Cash Pay, or No Bill
     */
    export enum billing_type {
        GLOBAL = 'global',
        CLIENT = 'client',
        NONE = 'none',
    }

    export enum billing_type_default {
        GLOBAL = 'global',
        CLIENT = 'client',
        NONE = 'none',
    }

    export enum type {
        CLINICAL = 'clinical',
        TEST = 'test',
        DEMO = 'demo',
        VALIDATION = 'validation',
        CONSULT = 'consult',
        CONTROL = 'control',
        TC_PC = 'tc-pc',
        HISTORICAL = 'historical',
    }


}
